import { render, staticRenderFns } from "./RecommendBook.vue?vue&type=template&id=520657cc&scoped=true&"
import script from "./RecommendBook.vue?vue&type=script&lang=js&"
export * from "./RecommendBook.vue?vue&type=script&lang=js&"
import style0 from "./RecommendBook.vue?vue&type=style&index=0&id=520657cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520657cc",
  null
  
)

export default component.exports